import React, { useState } from "react";
import Filters from "./Filters/Filters";

const FiltersContainer = (props) => {
  const [openFilter, setOpenFilter] = useState(props.defaultFilter);

  const changeFilter = (value) => () => {
    if (!props.disableFilters) {
      setOpenFilter(value);
    } else {
      props.handleFilterMessage();
    }
  };

  return (
    <Filters openFilter={openFilter} changeFilter={changeFilter} {...props} />
  );
};

export default FiltersContainer;
